export interface EnterHttpErrorOptions {
    status?: number;
    message: string;
    detail?: string;
    responseBody?: unknown;
    raw?: unknown;
    headers?: Headers;
    cause?: unknown;
}

/** 公共 API 层统一抛出的传输错误，保留服务端响应和原始错误便于宿主诊断。 */
export class EnterHttpError extends Error {
    readonly status?: number;
    readonly detail?: string;
    readonly responseBody?: unknown;
    readonly raw?: unknown;
    readonly headers?: Headers;
    readonly cause?: unknown;

    constructor(options: EnterHttpErrorOptions) {
        super(options.message);
        this.name = 'EnterHttpError';
        this.status = options.status;
        this.detail = options.detail;
        this.responseBody = options.responseBody;
        this.raw = options.raw ?? options.responseBody;
        this.headers = options.headers;
        if (options.cause !== undefined) {
            this.cause = options.cause;
        }
    }
}

/** 无法获取 access token，或鉴权请求明确需要重新登录时使用的错误。 */
export class AuthenticationRequiredError extends Error {
    readonly cause?: unknown;

    constructor(message = 'Authentication required', cause?: unknown) {
        super(message);
        this.name = 'AuthenticationRequiredError';
        this.cause = cause;
    }
}
